import { Injectable } from '@angular/core';
import { Permissao } from '@models/enums/permissao';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {

  constructor(private authService: AuthService) {}

  has(permissao: Permissao): boolean {
    return this.authService.isAuthorized(permissao);
  }
}
